import styled from 'styled-components';

import { Colors } from 'modules/ui/theme/colors';
import { H1 } from 'modules/ui/typography';

export const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-x: auto;
  padding: 0 16px 40px;
  background-color: ${Colors.LightGray};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: ${Colors.White};
  font-size: 13px;
  box-shadow: 0 4px 16px rgba(1, 7, 36, 0.08);

  th,
  td {
    border: 1px solid ${Colors.Gray};
    text-align: left;
    padding: 10px 12px;
  }

  th {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: ${Colors.White};
    color: ${Colors.Black};
    font-weight: 700;
    border-top: none;
    border-bottom: 2px solid ${Colors.Primary};
    box-shadow: 0 2px 6px rgba(1, 7, 36, 0.06);
  }
`;

export const TableRow = styled.tr<{ isMidnight: boolean; isNow: boolean }>`
  font-weight: ${({ isNow }): string | undefined =>
    isNow ? 'bold' : undefined};
  border-top: ${({ isMidnight }): string | undefined =>
    isMidnight ? `3px solid ${Colors.Black}` : undefined};
`;

export const DegreesCell = styled.td<{ value: number }>`
  background: ${`linear-gradient(90deg, ${Colors.Primary}99 0%, ${Colors.Primary}4D 100%)`};
  background-size: ${({ value }): string =>
    `${((typeof value === 'number' ? value : 0) / 360) * 100}%`};
  background-repeat: no-repeat;
`;

export const TwsCell = styled.td<{ color: string }>`
  background: ${({ color }): string =>
    `linear-gradient(90deg, ${color} 0%, ${color}99 100%)`};
`;

export const TwaCell = styled.td<{ value: number }>`
  color: ${({ value }): string =>
    value < 0 ? Colors.Destructive : Colors.Secondary};
`;

export const InfoTitle = styled(H1)`
  padding: 24px 16px 16px;
  font-weight: 700;
  color: ${Colors.Black};
`;
